import React, { useState } from 'react';
import { LINK_GUIDE } from '@src/constants/tts';
import { useTranslation } from 'react-i18next';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import TipsAndUpdatesRoundedIcon from '@mui/icons-material/TipsAndUpdatesRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { StyledTips } from './index.style';

import { StyledIconButton } from '../TTSNew/Requests/index.style';

const Tip = ({ onClose, hiddenClose, absolute }) => {
  const { t } = useTranslation();

  const TITLE_TIP_1 = 0;
  const TITLE_TIP_2 = 1;
  const TITLE_TIP_3 = 2;
  const TITLE_TIP_4 = 3;
  const TITLE_TIP_5 = 4;
  const TITLE_TIP_6 = 5;

  const [currentTip, setCurrentTip] = useState(TITLE_TIP_1);
  const contentsTip = {
    [TITLE_TIP_1]: {
      title: t('addHyphensBetweenWordsWithThePronunciationOfForeignWords'),
      key: 'exampleInformationPronunciation',
    },
    [TITLE_TIP_2]: {
      title: t('findVietnameseSyllablesCloseToThePronunciation'),
      key: 'exampleDoctorTrending',
    },
    [TITLE_TIP_3]: {
      title: t('xSIsPronouncedAsXShTIsPronouncedAsS'),
      key: 'exampleSixPersonUnderstandRelation',
    },
    [TITLE_TIP_4]: {
      title: t('chTrIsPronouncedAsTr'),
      key: 'exampleBeachChair',
    },
    [TITLE_TIP_5]: {
      title: t('kCIsPronouncedAsKOrCAccordingly'),
      key: 'exampleCreationBankSky',
    },
    [TITLE_TIP_6]: {
      title: t('keepConsonantsIfFollowedByAnotherConsonant'),
      key: 'exampleBrainClass',
    },
  };
  return (
    <div className="tips">
      {!hiddenClose && <div className="arrow-tip" />}
      <StyledTips
        absolute={absolute}
        isDisabledNext={currentTip === Object.keys(contentsTip)?.length - 1}
        isDisabledPrev={currentTip === 0}
      >
        <div className="header-tip">
          <div className="awesome-tip">
            <TipsAndUpdatesRoundedIcon className="tip-icon" />
            <div className="great-tip">{t('greatTips')}</div>
          </div>
          {!hiddenClose && (
            <StyledIconButton
              hiddenBorder
              height="40px"
              onClick={() => !!onClose && onClose()}
              width="40px"
              padding="12px"
            >
              <CloseRoundedIcon className="icon" />
            </StyledIconButton>
          )}
        </div>
        <div className="content-tip">
          <div className="title_content_tip">
            {contentsTip[currentTip]?.title}
          </div>
          <div className="title_content_content">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: t(contentsTip[currentTip]?.key),
              }}
            />
          </div>
        </div>
        <div className="bottom_tips">
          <a
            href={LINK_GUIDE}
            rel="noreferrer"
            target="_blank"
            className="link_view_tip hidden_border"
          >
            {t('viewDetail')}
          </a>
          <div className="btn-actions">
            <StyledIconButton
              height="40px"
              width="40px"
              padding="12px"
              onClick={() => {
                if (currentTip === 0) return;
                setCurrentTip((prev) => prev - 1);
              }}
              className="prevBtn"
            >
              <KeyboardArrowLeftRoundedIcon />
            </StyledIconButton>
            <div className="count-content">
              {currentTip + 1}/{Object.keys(contentsTip)?.length}
            </div>
            <StyledIconButton
              height="40px"
              width="40px"
              padding="12px"
              onClick={() => {
                if (currentTip === Object.keys(contentsTip)?.length - 1) return;
                setCurrentTip((prev) => prev + 1);
              }}
              className="nextBtn"
            >
              <ChevronRightRoundedIcon />
            </StyledIconButton>
          </div>
        </div>
      </StyledTips>
    </div>
  );
};

export default Tip;
